if (!customElements.get('variant-selects')) {

  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }
      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked'))
          .map(({ dataset }) => dataset.optionValueId)
          .filter(Boolean);
      }
      get sizeFormInput() {
        return this.querySelector('.product-form__input[data-size-option]');
      }
      get sizeErrorElement() {
        return this.parentElement?.querySelector(':scope > [data-size-error]');
      }
      hasSizeSelected() {
        const formInput = this.sizeFormInput;
        if (!formInput) return true;
        if (formInput.querySelector('input[type="radio"]:checked')) return true;
        const select = formInput.querySelector('select');
        return !!(select && select.value);
      }
      toggleSizeError(show) {
        const errorElement = this.sizeErrorElement;
        if (errorElement) errorElement.hidden = !show;
      }
      validateSizeSelection() {
        const isValid = this.hasSizeSelected();
        this.toggleSizeError(!isValid);
        return isValid;
      }
      // Re-applies labels/measurements after product-info restores the customer's choice into re-rendered markup.
      syncSelectedValues() {
        this.querySelectorAll('.product-form__input').forEach((formInput) => {
          const checkedRadio = formInput.querySelector('input[type="radio"]:checked');
          const select = formInput.querySelector('select');
          const value = checkedRadio ? checkedRadio.value : select?.value;
          const labelNode = formInput.querySelector('[data-selected-swatch-value]');
          if (value && labelNode) {
            labelNode.innerHTML = this.getDisplayLabel(value, labelNode.dataset.selectedSwatchValue || '');
          }
        });
        this.updateSelectedSizeDetails();
        this.refreshSizeState();
      }
      // A size counts as valid only when it is chosen and not marked unavailable.
      hasValidSizeSelected() {
        const formInput = this.sizeFormInput;
        if (!formInput) return true;
        const checkedRadio = formInput.querySelector('input[type="radio"]:checked');
        if (checkedRadio) return !checkedRadio.classList.contains('disabled');
        const select = formInput.querySelector('select');
        return !!(select && select.value && !select.selectedOptions[0]?.disabled);
      }
      // Syncs the container's `pdp_nosize_selected` class and clears the validation message once a size is chosen.
      refreshSizeState() {
        this.closest('.product__sizeand_variant_container')?.classList.toggle(
          'pdp_nosize_selected',
          !this.hasValidSizeSelected()
        );
        if (this.hasSizeSelected()) this.toggleSizeError(false);
        this.updateSku();
      }
      // Shows the chosen variant's SKU, or the product's default SKU (rendered in Liquid) while no size is selected.
      updateSku() {
        const skuBlock = document.getElementById(`Sku-${this.dataset.section}`);
        const skuValue = skuBlock?.querySelector('[data-sku-value]');
        if (!skuValue) return;
        // Any explicitly selected size shows its variant's SKU, including sold-out variants.
        const variant = this.hasSizeSelected() ? this.getSelectedVariant() : null;
        const sku = variant ? variant.sku || '' : skuValue.dataset.defaultSku;
        if (skuValue.textContent !== sku) skuValue.textContent = sku;
        skuBlock.classList.toggle('hidden', !sku);
      }
      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        // Runs on first load and whenever product-info swaps in re-rendered markup.
        this.updateSelectedSizeDetails();
        this.refreshSizeState();
        if (this.hasChangeListener) return;
        this.hasChangeListener = true;
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event);
          this.updateSelectedSizeDetails();
          this.refreshSizeState();
          this.updateVariantId();
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
        });
      }

      hideValueIfNoVariantChecked() {
        // Check all product form inputs
        this.querySelectorAll('.product-form__input').forEach(formInput => {
          // Check if any radio input is checked
          const hasCheckedRadio = formInput.querySelector('input[type="radio"]:checked');
          // Check if any select has a selected option
          const select = formInput.querySelector('select');
          const hasSelectedOption = select && select.querySelector('option[selected]');

          // If no variant is checked, clear the display value
          if (!hasCheckedRadio && !hasSelectedOption) {
            const selectedSwatchValue = formInput.querySelector('[data-selected-swatch-value], [data-selected-value]');
            if (selectedSwatchValue) {
              selectedSwatchValue.innerHTML = '';
            }
          }
        });
      }

      normalizeSizeLabel(value) {
        const sizeMap = {
          XXL: '2XL',
          XXXL: '3XL',
          XXXXL: '4XL',
          XXXXXL: '5XL',
        };
        return sizeMap[value] || value;
      }

      getDisplayLabel(value, optionName = '') {
        if (optionName.toLowerCase() === 'size') {
          return this.normalizeSizeLabel(value);
        }
        return value;
      }

      escapeHTML(value = '') {
        return String(value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;');
      }

	      updateSelectedSizeDetails() {
	        const fallbackSizeFormInput = this.querySelector('.product-form__input[data-option-name*="size"]');

	        this.querySelectorAll('[data-selected-size-details]').forEach((detailsNode) => {
	          const formInput = detailsNode.closest('.product-form__input') || fallbackSizeFormInput;
	          if (!formInput) return;
	
	          let sourceNode = formInput.querySelector('input[type="radio"]:checked');
	          if (!sourceNode) {
	            const select = formInput.querySelector('select');
            if (select && select.selectedOptions.length) sourceNode = select.selectedOptions[0];
          }

          if (!sourceNode) {
            detailsNode.textContent = '';
            detailsNode.hidden = true;
            return;
          }

          const parts = [];
          const mappings = [
            ['sizeChartChest', 'Chest'],
            ['sizeChartWaist', 'Waist'],
          ];

          mappings.forEach(([datasetKey, label]) => {
            const value = sourceNode.dataset[datasetKey];
            if (value) parts.push(`${label}: ${this.escapeHTML(value)} in`);
          });
          detailsNode.innerHTML = parts.join('&nbsp;&nbsp;&nbsp;');
          detailsNode.hidden = parts.length === 0;
        });
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;
        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.hasAttribute('selected'))
            ?.removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');
          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (selectedDropdownSwatchValue) {
            if (swatchValue) {
              selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
              selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
            } else {
              selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
              selectedDropdownSwatchValue.classList.add('swatch--unavailable');
            }
            selectedDropdownSwatchValue.style.setProperty(
              '--swatch-focal-point',
              target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
            );
          }
          const selectedTextNode = target.closest('.product-form__input').querySelector('[data-selected-swatch-value]');
          if (selectedTextNode) {
            const optionName = selectedTextNode.dataset.selectedSwatchValue || '';
            selectedTextNode.innerHTML = this.getDisplayLabel(target.selectedOptions[0].value, optionName);
          }
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          // Update checked attribute for selected variant
          const formInput = target.closest('.product-form__input');
          const radioName = target.name;
          const allRadios = Array.from(formInput.querySelectorAll('input[type="radio"]')).filter(radio => radio.name === radioName);
          allRadios.forEach(radio => {
            if (radio === target) {
              radio.setAttribute('checked', 'checked');
            } else {
              radio.removeAttribute('checked');
            }
          });

          const selectedSwatchValue = formInput.querySelector('[data-selected-swatch-value], [data-selected-value]');
          if (selectedSwatchValue) {
            const optionName = selectedSwatchValue.dataset.selectedSwatchValue || '';
            selectedSwatchValue.innerHTML = this.getDisplayLabel(value, optionName);
          }
        }
      }

      getVariantData() {
        if (this.variantData !== undefined) return this.variantData;
        const variantScript = this.querySelector('[data-product-variants]');
        try {
          this.variantData = variantScript ? JSON.parse(variantScript.textContent) : null;
        } catch (e) {
          this.variantData = null;
        }
        return this.variantData;
      }

      getSelectedOptionStrings() {
        const selectedValues = [];
        this.querySelectorAll('.product-form__input').forEach(formInput => {
          const checkedRadio = formInput.querySelector('input[type="radio"]:checked');
          if (checkedRadio) {
            selectedValues.push(checkedRadio.value);
            return;
          }
          const select = formInput.querySelector('select');
          if (select && select.value) {
            selectedValues.push(select.value);
            return;
          }
          selectedValues.push(null);
        });
        return selectedValues;
      }

      getSelectedVariant() {
        const variants = this.getVariantData();
        if (!variants) return null;
        const selectedValues = this.getSelectedOptionStrings();
        if (!selectedValues.length || selectedValues.includes(null)) return null;
        return variants.find(variant =>
          selectedValues.every((value, index) => variant[`option${index + 1}`] === value)
        ) || null;
      }

      updateVariantId() {
        const matchingVariant = this.getSelectedVariant();
        if (!matchingVariant) return;
        const sectionId = this.dataset.section;
        document.querySelectorAll(`#product-form-${sectionId}, #product-form-installment-${sectionId}`)
          .forEach(form => {
            const idInput = form.querySelector('input[name="id"]');
            if (idInput) idInput.value = matchingVariant.id;
          });
      }
    }
  );

  // Block add-to-bag until a size is chosen. Runs in the window capture phase so it fires before
  // ProductForm's submit handler, the sticky bar's proxy click and the analytics click listeners.
  const getVariantSelectsFor = (element) => {
    const productInfo = element.closest('product-info');
    if (productInfo) return productInfo.querySelector('variant-selects');
    // The sticky bar lives outside product-info and proxies clicks to the main product form.
    if (element.closest('.product-form__submit_sticky')) {
      return document.querySelector('product-info[id^="MainProduct"] variant-selects');
    }
    return null;
  };

  const blockIfSizeMissing = (event, trigger) => {
    const variantSelects = getVariantSelectsFor(trigger);
    if (!variantSelects || variantSelects.validateSizeSelection()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    // The note is already visible at this point (validateSizeSelection un-hides it); center it so
    // sticky headers or the sticky add-to-cart bar can't cover it.
    variantSelects.sizeErrorElement?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  window.addEventListener(
    'click',
    (event) => {
      const trigger = event.target.closest?.('.product-form__submit, .product-form__submit_sticky');
      if (!trigger || trigger.disabled) return;
      blockIfSizeMissing(event, trigger);
    },
    true
  );

  window.addEventListener(
    'submit',
    (event) => {
      if (!event.target.matches?.('form[is="product-form"]')) return;
      blockIfSizeMissing(event, event.target);
    },
    true
  );
}
